/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1442
 */

var r = require(/* 1443 */"./1443")
var i = require(/* 1179 */"../2545/1179/index")
var o = require(/* 862 */"../../../../2466/1167/1431/862/index")
module.exports = function (e) {
  return r(e, o, i)
}
